(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  /*
   * Cart Deals Popup
   * ─────────────────────────────────────────────────────────────────────────
   * Uses event delegation on `document` so clicks still work after the cart
   * drawer re-renders its HTML via AJAX (theme:cart:change).
   *
   * Trigger : [data-deals-trigger]  — the per-deal "advance-pairs-link" buttons
   * Close   : [data-deals-close]   — X button inside each dialog
   *           Clicking the ::backdrop also closes the dialog
   */
  (function () {
    // ── Open ──────────────────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-deals-trigger]');
      if (!trigger) return;

      e.preventDefault();

      var dialogId = trigger.getAttribute('data-deals-trigger');
      var dialog   = document.getElementById(dialogId);
      if (!dialog) return;

      // Guard against rapid/repeated clicks: showModal() throws if already open.
      if (dialog.open) return;

      dialog.showModal();
      dialog.setAttribute('aria-hidden', 'false');
    });

    // ── Close via X button ─────────────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-deals-close]');
      if (!btn) return;

      var dialogId = btn.getAttribute('data-deals-close');
      var dialog   = document.getElementById(dialogId);
      if (dialog) dialog.close();
    });

    // ── Close via backdrop click ───────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var dialog = e.target.closest('dialog.cart-deals__dialog');
      if (!dialog || !dialog.open) return;

      var rect = dialog.getBoundingClientRect();
      var clickedBackdrop = (
        e.clientX < rect.left  ||
        e.clientX > rect.right ||
        e.clientY < rect.top   ||
        e.clientY > rect.bottom
      );
      if (clickedBackdrop) dialog.close();
    });

    // ── Sync aria-hidden on native close (ESC key etc.) ───────────────────
    document.addEventListener('close', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('cart-deals__dialog')) {
        e.target.setAttribute('aria-hidden', 'true');
      }
    }, true);

    // ── Copy promo codes inside cart deal dialogs ─────────────────────────
    document.addEventListener('click', function (e) {
      var codeEl = e.target.closest('[data-copy-code]');
      if (!codeEl || !codeEl.closest('.cart-deals__dialog')) return;

      var code  = codeEl.getAttribute('data-copy-code');
      var label = codeEl.querySelector('.available-deal-item__code-label');
      if (!code || !label) return;

      var prev = label.textContent;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          label.textContent = 'Copied!';
          setTimeout(function () { label.textContent = prev; }, 1800);
        });
      } else {
        var tmp = document.createElement('input');
        tmp.value = code;
        document.body.appendChild(tmp);
        tmp.select();
        document.execCommand('copy');
        document.body.removeChild(tmp);
        label.textContent = 'Copied!';
        setTimeout(function () { label.textContent = prev; }, 1800);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
